import React, { PropsWithChildren } from "react";

export const Seo = ({
  title,
  follow = true,
  index = true,
  children,
}: PropsWithChildren<{
  title?: string | string[];
  follow?: boolean;
  index?: boolean;
}>) => {
  const seo = {
    title: [
      ...(Array.isArray(title) ? title : [title]),
      "Kinderbetreuung in Moers und Kamp-Lintfort",
      "Fokus Familie gGmbH",
    ]
      .filter((part) => part && typeof part === "string" && part.length > 0)
      .join(" | "),
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta
        name="robots"
        content={[
          index ? "index" : "noindex",
          follow ? "follow" : "nofollow",
        ].join(", ")}
      />
      {children}
    </>
  );
};
